(function ($) {
    $(document).ready(function () {

        $('.accordion').on('click', '.js-accordion-header', function (e) {
            var $header = $(this);
            var isParent = $header.hasClass('parent-with-children');

            // If NO children → allow normal navigation
            if (!isParent) {
                return;
            }

            // Has children → accordion behavior
            e.preventDefault();

            var $item = $header.closest('.accordion__item');
            var $body = $item.children('.accordion__body');

            $item.toggleClass('is-open');
            $body.stop(true, true).slideToggle(300);
        });

    });
})(jQuery);
